<template>
  <div>
    <section class=" container section is-main-section">
      <div>
        <v-card-component title="Center 1st Audit">
          <v-col>
            <v-card-actions>
              <router-link slot="right" :to="{ name: 'amsConfiguration' }">
                <v-btn
                  elevation="1"
                  absolute
                  right
                  top
                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
              </router-link>
            </v-card-actions>
          </v-col>
          <v-row>
            <v-col>
              <v-row>
                <v-col v-if="zonal_Manager === false" style="margin-left: 10px;" cols="12" md="2" sm="2" xs="12">
                  <v-autocomplete
                    key="id"
                    :items="zones"
                    v-model="zoneID"
                    item-text="name"
                    item-value="id"
                    @change="getAcademicManagerList()"
                  >
                    <template v-slot:label> Select Zone </template>
                  </v-autocomplete>
                </v-col>
                <v-col style="margin-left: 10px;" cols="12" md="4" sm="2" xs="12">
                  <v-autocomplete
                    key="id"
                    :items="academicManagerList"
                    v-model="academicManagerId"
                    item-text="academicManagerName"
                    item-value="id"
                  >
                    <template v-slot:label> Select Academic Manager </template>
                  </v-autocomplete>
                </v-col>
                <v-col style="margin-left: 10px;" cols="12" md="2" sm="2" xs="12">
                  <div class="d-flex justify-end caption">
                    <v-btn
                      small
                      id="apply"
                      color="success"
                      elevation="1"
                      type="submit"
                      class="ml-2 mt-5"
                      @click="getFirstAuditData('filter')"
                    >
                      <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                      Filter
                    </v-btn>
                    <v-btn

                      small
                      elevation="1"
                      type="reset"
                      class="ml-2 mt-5"
                      @click="resetAll()"
                    >
                      <v-icon left size="18"> mdi-restart</v-icon> Clear
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-component>
      </div>
    </section>
    <section class=" container section is-main-section" v-if="(isSuperAdmin === false) || (isSuperAdmin === true && zoneID != '' && satable === true)">
      <v-data-table
        item-key="id"
        :headers="headers"
        :items="firstAuditList"
      >
        <template v-slot:item.firstAuditDate="{ item }" >
          <span v-if="item.firstAuditDate === null">
            <v-btn
              outlined
              class="px-2 ml-1 ma-1"
              color="accent"
              min-width="0"
              small
              elevation="1"
              @click="selectDate(item)"
            >
              Calender To Select Date
            </v-btn>
          </span>
          <span v-else>
            {{ item.firstAuditDate }}
          </span>
        </template>
      </v-data-table>
    </section>
    <template>
      <v-dialog ref="dialog1" v-model="openCalender" persistent width="290px">
        <v-date-picker v-model="startDate" scrollable type='date' >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="openCalender = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="confirmDate()">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import stores from '@/stores'
import moment from 'moment'
// import CustomDatePicker from '@/components/template/CustomDatePicker'
// import VDateInput from 'v-date-input'

export default {
  name: 'centerFirstAudit',
  components: { VCardComponent },
  data () {
    return {

      headers: [
        {
          text: 'Zone',
          value: 'name',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Reporting Zonal Manager',
          value: 'zonalManagerName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Academic Manager',
          value: 'academicManagerName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'First Audit Date',
          value: 'firstAuditDate',
          sortable: true,
          align: 'center'
        }
        // {
        //   text: 'Action',
        //   value: 'actions',
        //   sortable: false,
        //   align: 'center'
        // }
      ],

      zones: [],
      zoneID: '',
      academicManagers: [],
      academicManagerId: '',
      academicManagerList: [],
      firstAuditList: [],
      userid: '',
      showCalendar: false,
      selectedDate: null,
      dateValue: '',

      modal: false,
      startDate: '',
      openCalender: false,
      amData: '',
      isSuperAdmin: false,
      satable: false,
      zonal_Manager: false
    }
  },
  computed: {
    // computedHeaders () {
    //   if (this.isSuperAdmin) {
    //     return this.headers.filter(header => header.value !== 'actions')
    //   }
    //   return this.headers
    // }
  },
  created: async function () {
    this.userid = stores.user.userInfo.id
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    if (!this.isSuperAdmin) {
      for (const item of userStore.roles) {
        if (item.role === 'AMS_ZonalManager') {
          this.zonal_Manager = true
        }
      }
    }
    if (this.zonal_Manager === true) {
      await this.getAcademicManagerList()
      this.firstAuditList = []
      console.log(this.firstAuditList, '---------------------')
    }
    await this.getZones()
    if (!this.isSuperAdmin) {
      await this.getFirstAuditData()
    }
  },
  methods: {
    getZones: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/get/zones`
        )
        this.zones = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getAcademicManagerList: async function () {
      try {
        this.firstAuditList = []
        this.academicManagerId = ''
        let payload = {}
        if (this.zonal_Manager === true) {
          payload.zmUserId = this.userid
        } else {
          payload.zoneId = this.zoneID ? this.zoneID : ''
        }
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/configuration/firstAudit/getAcademicManagerList`, payload
        )
        this.academicManagerList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getFirstAuditData: async function (status) {
      try {
        if (status) {
          this.satable = true
        }

        const payload = {
          'zoneId': this.zoneID,
          'amId': this.academicManagerId ? this.academicManagerId : ''
        }
        if (!this.isSuperAdmin) {
          payload['userID'] = this.userid
        }

        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/configuration/firstAudit/getFirstAuditData`, payload
        )
        this.firstAuditList = response.data
        for (const item of this.firstAuditList) {
          item.firstAuditDate = item.firstAuditDate ? moment(item.firstAuditDate).format('DD/MM/YYYY') : null
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        this.firstAuditList = []
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    resetAll: function () {
      this.zoneID = ''
      this.academicManagerId = ''
      this.satable = false
      if (this.isSuperAdmin) {
        this.academicManagerList = []
      }
      this.getFirstAuditData()
    },
    selectDate: function (item) {
      this.openCalender = true
      this.amData = item
    },
    confirmDate: async function () {
      try {
        this.openCalender = false
        this.startDate = this.startDate ? moment(this.startDate).format('YYYY/MM/DD') : ''
        const response = await http.put(
          `${constants.API_URL}/api/amsScheduling/configuration/firstAudit/updateFirstAuditDate`,
          {
            'amId': this.amData.id,
            'firstAuditDate': this.startDate
          }
        )
        if (response.data.status === 200) {
          this.getFirstAuditData()
          return this.$buefy.dialog.alert({
            type: 'is-info',
            message: response.data.message,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        this.openCalender = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}

</script>
